import React, {useContext, useEffect, useRef, useState} from 'react';
import {AgGridReact} from "ag-grid-react";
import {AgentContext} from "../../context/agent-context.jsx";
import GenericEditRemoveCellRenderer from "./generic-edit-remove-cell-renderer.jsx";
import {v4 as uuidv4} from 'uuid';
import ConfirmationDeleteList from "../../../../../../components/utils/confirmation-delete-lists.jsx";
import {FaPlus} from "react-icons/fa";
import Swal from "sweetalert2";
import {Card} from "../../../../../../components/card/card.jsx";
import Button from "../../../../../../components/button/button.jsx";
import aggridUtils from "../../../../../../utils/aggrid-utils.js";
import {Modal} from "../../../../../../components/modal/modal.jsx";
import InputForm from "../../../../../../components/input/input-form.jsx";
import SelectComponent from "../../../../../../components/select/select-component.jsx";
import optionsUtils from "../../../../../../utils/options-utils.js";
import InputDateTime from "../../../../../../components/input/input-datetime.jsx";
import {format} from "date-fns";
import projectUtils from "../../../../../../utils/project-utils.js";

const initialData = {
    itemId: null,
    dependentName: "",
    dependentBirth: "",
    kinship: null
}

const Dependent = () => {
    const gridRef = useRef();
    const {user, setUser, setChanges, setTabSelected, setCpfFocus} = useContext(AgentContext)
    const [data, setData] = useState(initialData)
    const [open, setOpen] = useState(false);

    const remove = (data) => {
        ConfirmationDeleteList(() => {
            setUser(prev => ({
                ...prev,
                dependents: prev.dependents.filter(dep => dep.itemId !== data.itemId)
            }));

            setChanges('dependents');
        })
    }

    const [columnDefs] = useState([
        {headerName: "Nome", field: "dependentName", flex: 1, comparator: aggridUtils.nullLastComparator},
        {
            headerName: "Parentesco", field: "kinship",
            valueFormatter: ({value}) => {
                const kinship = optionsUtils.kinship.find(option => option.value === value)
                if (kinship) return kinship.label;

                return null;
            }, comparator: aggridUtils.nullLastComparator
        },
        {
            headerName: "Nascimento", field: "dependentBirth",
            valueFormatter: ({value}) => {
                if (value) return projectUtils.formatDate(value + 'T00:00:00', 'DD/MM/YYYY');

                return null;
            }, comparator: aggridUtils.nullLastComparator
        },
        {
            headerName: "", field: "", width: 100,
            cellRenderer: GenericEditRemoveCellRenderer,
            cellRendererParams: {setData, setOpen, remove}
        },
    ]);

    const handleInputs = ({target: {value, id}}) => setData(prev => ({...prev, [id]: value}));

    const handleDate = (id, value) => {
        const dateFormated = value ? format(value, "yyyy-MM-dd") : null
        setData(prev => ({...prev, [id]: dateFormated}))
    };

    const save = () => {
        const {dependents} = user;
        if (data.itemId) {
            setUser(prev => ({
                ...prev,
                dependents: prev.dependents.map(dep =>
                    dep.itemId === data.itemId ? data : dep
                )
            }));
        } else {
            data.itemId = uuidv4();
            setUser(prev => ({...prev, dependents: [...dependents, data]}))
        }

        setChanges('dependents');
        onHide();
    }

    const onHide = () => {
        setData(initialData);
        setOpen(false)
    }

    const handleClick = () => {
        if (!user.general.cpf) {
            Swal.fire({
                title: "Atenção",
                text: "Informe o CPF para incluir dependentes.",
                icon: "warning",
                confirmButtonText: "Continuar",
                confirmButtonColor: "#063A6C",
                cancelButtonText: "Cancelar",
                showCancelButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then(({isConfirmed}) => {
                if (isConfirmed) {
                    setTabSelected("general")
                    setCpfFocus(true)
                }
            });
        } else {
            setOpen(true)
        }
    }
    const prepareData = (value) => {
        if (value) {
            const parts = value.split("-");
            return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
        }
    }

    return (
        <>
            <Card>
                <Card.Header className={"gap-2"}>
                    <Card.Title>Dependentes</Card.Title>
                    <Button className={"h-[30px] w-[30px] !p-0"} onClick={handleClick}>
                        <FaPlus />
                    </Button>
                </Card.Header>
                <Card.Body>
                    <div className={"h-[calc(100vh-196px)]"}>
                        <AgGridReact
                            ref={gridRef}
                            rowData={user.dependents}
                            columnDefs={columnDefs}
                            animateRows={false}
                            suppressCellFocus={true}
                            gridOptions={{localeText: aggridUtils.localization()}}
                            theme={aggridUtils.generalTheme()}
                        />
                    </div>
                </Card.Body>
            </Card>

            <Modal isCloseClick={false} open={open} setOpen={onHide} className={"w-4/12"}
                   title={data.itemId ? "Editar dependente" : "Adicionar dependente"} overflow={true} >
                <Modal.Body className="p-2">
                    <div className="row">
                        <div className="col-span-12">
                            <InputForm id="dependentName" value={data.dependentName} label="Nome" onChange={handleInputs}/>
                        </div>

                        <div className="col-span-12">
                            <SelectComponent
                                id="kinship"
                                value={optionsUtils.kinship.find(option => option.value === data.kinship)}
                                options={optionsUtils.kinship}
                                label={"Parentesco"}
                                onChange={(selected) => setData(prev => ({...prev, kinship: selected.value}))}
                            />
                        </div>

                        <div className={"col-sssssspan-12"} style={{height: "35px"}}>
                            <div className="form-outline-custom">
                                <InputDateTime
                                    id={"dependentBirth"}
                                    selected={data.dependentBirth}
                                    label={"Nascimento"}
                                    dateFormat={"L"}
                                    onChange={(date) => handleDate("dependentBirth", date)}
                                />
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className={"p-2"}>
                    <div className={"w-full flex justify-end"}>
                        <Button onClick={save}>
                            Confirmar
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default Dependent;